<!-- 使う一覧のSheetの右部ステイタス表示 -->
<template>
  <!--------- 特急券クーポン --------->
  <div v-if="myCoupon">
    <!-- 引換え可 -->
    <div v-if="isExchangeable">
      <div class="index-ticket-right">
        <div v-if="isMultiple">
          <div class="button_text_multiple" @click="goToMFITT()">引換え</div>
          <div class="button_text_count">
            ({{ myCoupon.used_count }}/{{ myCoupon.use_limit }})
          </div>
        </div>
        <div v-else>
          <div class="button__text" @click="goToMFITT()">引換え</div>
        </div>
      </div>
    </div>
    <!-- 引換え可 -->

    <!-- 引換え不可 -->
    <div v-else class="index-ticket-right">
      <!-- 使用済み -->
      <div v-if="isUsedCoupon">
        <div v-if="isMultiple">
          <div class="button_text_multiple">引換済</div>
          <div class="button_text_count">
            ({{ myCoupon.used_count }}/{{ myCoupon.use_limit }})
          </div>
        </div>
        <div v-else>
          <div class="button__text">引換済</div>
        </div>
      </div>
      <!-- 使用済み -->
      <!-- 期間外 -->
      <div v-else>
        <div v-if="isMultiple">
          <div class="button_text_count">
            ({{ myCoupon.used_count }}/{{ myCoupon.use_limit }})
          </div>
        </div>
      </div>
      <!-- 期間外 -->
    </div>
    <!-- 引換え不可 -->
  </div>
  <!--------- 特急券クーポン --------->

  <!--------- 特急券クーポン以外 ------>
  <div v-else>
    <!-- 使用済み -->
    <div
      v-if="sheet.is_expired && countDown === '00:00:00:00'"
      class="index-ticket-right button_used"
      @click="goToSheet(bookGroup, sheet)"
    >
      <div class="button__text">使用済</div>
    </div>
    <!-- 使用済み -->

    <!-- 期限外 -->
    <div
      v-else-if="countDown === null && isAvailablePeriod == false"
      class="index-ticket-right button_is_not_in_period"
      @click="goToSheet(bookGroup, sheet)"
    >
      <div class="button__text">期間外</div>
    </div>
    <!-- 期限外 -->

    <!-- 使用中 -->
    <div
      v-else-if="countDown !== null && countDown !== '00:00:00:00'"
      class="index-ticket-right button_valid"
      @click="goToSheet(bookGroup, sheet)"
    >
      <div class="button__text">使用中</div>
    </div>
    <!-- 使用中 -->

    <!-- 使う -->
    <div
      v-else-if="
        (countDown === null && isAvailablePeriod === true) ||
        (!sheet.is_expired && countDown === '00:00:00:00')
      "
      class="index-ticket-right"
      @click="goToSheet(bookGroup, sheet)"
    >
      <div class="button__text">使う</div>
    </div>
    <!-- 使う -->
  </div>
  <!--------- 特急券クーポン以外 ------>
</template>

<script>
import { computed, inject } from "vue";

import nativeHandlerService from "@/services/nativeHandler";
import mfittService from "@/services/MFITT";

export default {
  name: "SUseStatusButton",
  props: {
    bookGroup: {
      type: Object,
      required: true,
    },
    sheet: {
      type: Object,
      required: true,
    },
    myCoupon: {
      type: Object,
      default: null,
    },
    isAvailablePeriod: {
      type: Boolean,
      required: true,
    },
    isUsedCoupon: {
      type: Boolean,
      required: true,
    },
    countDown: {
      type: String,
      default: null,
      // required: trueにすると、nullの場合warning出るので書かない。でも必須
    },
  },
  setup(props) {
    const openDialogGroupUseWarning = inject("openDialogGroupUseWarning");

    const shouldShowGroupUseWarning = () => {
      const groupUse =
        props.bookGroup._master_book?.content?.description_json?.GroupUse;
      // アプリではグループ利用で、かつ、複数枚のチケットがある場合は、ダイアログを表示して、利用は不可です。
      if (groupUse === true && props.bookGroup.books.length > 1) {
        openDialogGroupUseWarning();
        return true;
      }
      return false;
    };

    const isExchangeable = computed(
      () =>
        props.myCoupon.is_exchangeable &&
        // 渋沢-足柄のように特急の発駅がないクーポンの場合は無効とする
        props.myCoupon.allowed_from_stations.length > 0 &&
        props.myCoupon.allowed_to_stations.length > 0
    );
    const isMultiple = computed(() => props.myCoupon.use_limit > 1);

    const goToSheet = (selectedBookGroup, sheet) => {
      let sheetIds = [];
      let masterSheetID = null;

      if (shouldShowGroupUseWarning()) return;
      
      selectedBookGroup.books.forEach(function (_book) {
        _book.sheets.forEach(function (sheetEach) {
          if (sheet.master_sheet_id == sheetEach.master_sheet_id) {
            sheetIds.push(sheetEach.id);
            masterSheetID = sheetEach.master_sheet_id;
          }
        });
      });
      if (process.env.NODE_ENV == "local") {
        window.location.href = `http://${window.location.host}/#/my-tickets/ticketing/${selectedBookGroup.id}/master-sheet/${masterSheetID}/sheet/${sheetIds}`;
      } else {
        nativeHandlerService.openTicket(
          `${process.env.VUE_APP_EMOT2_WEBVIEW_URL}my-tickets/ticketing/${selectedBookGroup.id}/master-sheet/${masterSheetID}/sheet/${sheetIds}`
        );
      }
    };

    // 特急券予約・購入画面へ遷移する。
    const goToMFITT = () => {
      mfittService.goToBooking1WithCoupon(props.myCoupon.id);
    };

    return {
      goToSheet,
      goToMFITT,
      isExchangeable,
      isMultiple,
    };
  },
};
</script>
<style lang="scss" scoped>
.index-ticket-right {
  height: 51px;
  width: calc(23% - 4% - 1px);
  float: left;
  border-left: 1px dashed #d7d7d7;
  position: relative;
  border-radius: 0px 0px 5px 0px;
}

@media screen and (min-width: 421px) {
  .index-ticket-right {
    height: 12vw;
  }
}

.button_used {
  background: #e0e0e0;
  margin-top: -1px;
}

.button_valid {
  color: white;
  background: #f76666;
  margin-top: -1px;
}

.button_is_not_in_period {
  color: #f76666;
  margin-top: -1px;
}

.button__text {
  width: 100%;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  font-size: 3.5vw;
  font-weight: bold;
}

.button_text_multiple {
  width: 100%;
  text-align: center;
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  font-size: 3.5vw;
  font-weight: bold;
}

.button_text_count {
  width: 100%;
  text-align: center;
  position: absolute;
  top: 65%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  font-size: 3vw;
  font-weight: bold;
}
</style>
